export const baseURL = process.env.REACT_APP_API_ENDPOINT
export const mlbaseURL = process.env.REACT_APP_ML_API_ENDPOINT

export const version = require('../../package.json').version

export const sendBirdConfig = {
  appId: process.env.REACT_APP_SENDBIRD_APP_ID,
  // apiToken: process.env.REACT_APP_SENDBIRD_APP_TOKEN,
  apiUrl: 'https://api.sendbird.com'
}

export const roleLevel = {
  User: 1 << 0,
  Assistant: 1 << 1,
  Service_Provider: 1 << 2,
  partner_expert: 6,
  Coach: 1 << 3,
  Expert: 1 << 4,
  InternalAdmin: 1 << 5,
  Manager: 1 << 10
}

export const userType = {
  Core: 0,
  Non_Core: 1,
  Test_User: 2,
  Partners: 3,
  Archive: 6,
  Prospect: -1
}

export const pattern = {
  email: /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/,
  integer: /^[0-9]*[1-9][0-9]*$/,
  floatNumber: /^(-)?\d+(\.\d{1,2})?$/,
  positiveNumber: /^\d+((\.\d{1,2})?|\.)$/,
  positiveNumberWithOneDigits: /^\d+((\.\d{1})?|\.)$/,
  usPhoneNumber: /^(1?|(1-)?)\d{10}$/,
  E164Number: /^\+[1-9]\d{4,14}$/,
  cvvNumber: /^\d{3,4}$/,
  creditCardExpDate: /^\d\d\/\d\d$/,
  creditCardNumber: /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/,
  // eslint-disable-next-line no-useless-escape
  matchBoldQuestionTitle: /\*{2}[^\*]+\*{2}/gi,
  DomainRegex: /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/gim,
  URLRegex: /(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?/gim,
  URL: /((https|http|ftp|rtsp|mms)?:\/\/)[^<|"|\\]+/gim,
  // eslint-disable-next-line no-useless-escape
  phoneOrFaxNumber: /\+?[0-9]+(\-?[0-9]+)*$/
  // image: /<img [^>]*src=['"][^'"]+)[^>]*>/g
}

export const workoutPillarColors = {
  sleep: {
    primary: '#5C00D1',
    light: '#E2CCFF'
  },
  nutrition: {
    primary: '#7BAD2D',
    light: '#E9F4D7'
  },
  exercise: {
    primary: '#FF6B00',
    light: '#FEE2CD'
  }
}

// #40C47C - Emerald
// #7BAD2D - Green
// #FFB800 - Yellow
// #FF6B00 - Orange
// #DF0726 - Red
export const RangeColors = {
  emerald: '#40C47C',
  green: '#7BAD2D',
  blue: '#86C2D8',
  yellow: '#FFB800',
  orange: '#FF6B00',
  red: '#DF0726'
}

export const RecommendationColors = {
  emerald: '#40C47C',    // Kept as is - vibrant emerald
  green: '#7BAD2D',      // Kept as is - natural green
  blue: '#86C2D8',       // Kept as is - calm blue
  teal: '#20B2AA',       // New - medium intensity
  purple: '#9370DB',     // New - higher intensity
  indigo: '#4B0082'      // New - highest intensity (replacing red)
}

const colorArr = [
  {
    key: 'emerald',
    value: RangeColors.emerald
  },
  {
    key: 'green',
    value: RangeColors.green
  },
  {
    key: 'blue',
    value: RangeColors.blue
  },
  {
    key: 'yellow',
    value: RangeColors.yellow
  },
  {
    key: 'orange',
    value: RangeColors.orange
  },
  {
    key: 'red',
    value: RangeColors.red
  }
]

export const colors = colorArr
// [
//   {
//     key: 'red',
//     value: '#C94949'
//   },
//   {
//     key: 'green',
//     value: '#40C47C'
//   },
//   {
//     key: 'yellow',
//     value: '#EFBB00'
//   }
// ]

export const detailColors = colorArr
// [
//   {
//     key: 'red',
//     value: '#FF6B00'
//   },
//   {
//     key: 'green',
//     value: '#53B43B'
//   },
//   {
//     key: 'yellow',
//     value: '#FFB800'
//   }
// ]

export const errorMessage = {
  notMatchOptionsLength: 'The number of ranges cannot be more than choices!',
  loseTokenTitle: 'Your token is lost!',
  loseTokenContent: 'Please sign in again'
}

export const staticTrackingOuraMetric = [
  {
    key: 'origin-Total Sleep Time',
    value: 'origin-Total Sleep Time',
    title: 'Total Sleep Time',
    children: [
      {
        key: 'Sleep Time - Asleep',
        value: 'Sleep Time - Asleep',
        title: 'Sleep Time - Asleep'
      },
      {
        key: 'Sleep Time - In Bed',
        value: 'Sleep Time - In Bed',
        title: 'Sleep Time - In Bed'
      }
    ]
  },
  {
    key: 'origin-Bed Time',
    value: 'origin-Bed Time',
    title: 'Bed Time',
    children: [
      {
        key: 'Bed Time',
        value: 'Bed Time',
        title: 'Bed Time'
      },
      {
        key: 'Wake-up Time',
        value: 'Wake-up Time',
        title: 'Wake-up Time'
      }
    ]
  },
  {
    key: 'origin-Sleep Stages',
    value: 'origin-Sleep Stages',
    title: 'Sleep Stages',
    children: [
      {
        key: 'SleepAwake',
        value: 'SleepAwake',
        title: 'SleepAwake'
      },
      {
        key: 'SleepRem',
        value: 'SleepRem',
        title: 'SleepRem'
      },
      {
        key: 'SleepLight',
        value: 'SleepLight',
        title: 'SleepLight'
      },
      {
        key: 'SleepDeep',
        value: 'SleepDeep',
        title: 'SleepDeep'
      }
    ]
  },
  {
    key: 'origin-Heart Rate',
    value: 'origin-Heart Rate',
    title: 'Heart Rate',
    children: [
      {
        key: 'SleepMaxHeartRate',
        value: 'SleepMaxHeartRate',
        title: 'SleepMaxHeartRate'
      },
      {
        key: 'SleepMinHeartRate',
        value: 'SleepMinHeartRate',
        title: 'SleepMinHeartRate'
      },
      {
        key: 'SleepAvgHeartRate',
        value: 'SleepAvgHeartRate',
        title: 'SleepAvgHeartRate'
      }
    ]
  },
  {
    key: 'origin-Sleep Efficiency',
    value: 'origin-Sleep Efficiency',
    title: 'Sleep Efficiency',
    children: [
      {
        key: 'SleepEfficiency',
        value: 'SleepEfficiency',
        title: 'SleepEfficiency'
      }
    ]
  },
  {
    key: 'origin-Heart Rate Variation',
    value: 'origin-Heart Rate Variation',
    title: 'Heart Rate Variation',
    children: [
      {
        key: 'SleepHeartRateVariation',
        value: 'SleepHeartRateVariation',
        title: 'SleepHeartRateVariation'
      },
      {
        key: 'SleepMaxHeartRateVariation',
        value: 'SleepMaxHeartRateVariation',
        title: 'SleepMaxHeartRateVariation'
      },
      {
        key: 'SleepMinHeartRateVariation',
        value: 'SleepMinHeartRateVariation',
        title: 'SleepMinHeartRateVariation'
      }
    ]
  }
]

export const publicPath = [
  '/ui',
  '/register',
  '/password-reset',
  '/privacy',
  '/permanent_link/',
  '/creport/preview/',
  '/app/share-link/',
  '/ios/share-link/',
  '/share-link/',
  '/sign-in',
  '/terms-of-use',
  '/privacy-policy',
  '/check-in',
  '/facility-waiver',
  '/support',
  '/mobile',
  '/redirect/'
]

export const noCheckPath = [
  '/redirect-sign-waiver-form',
  '/questionnaire/nutrition-score',
  '/membership-selection',
  '/membership-agreement',
  '/onboarding'
]

export const fontFamily =
  'Lato,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"'

/* cheking before push code */
// const env = process.env.REACT_APP_WORKFLOW

// staging

const sections = [
  {
    name: 'Goals',
    value: 1
  },
  { name: 'Contacts', value: 2 },
  {
    name: 'Medical History',
    value: 3
  },
  {
    name: 'Lifestyle',
    value: 4
  },
  {
    name: 'Physical Activity',
    value: 5
  },
  {
    name: 'Orthopedic',
    value: 6
  },
  {
    name: 'Nutrition & Eating Habits',
    value: 7
  },
  {
    name: 'Sleep',
    value: 8
  }
]

// const stagingQuestionSection = [
//   {
//     name: 'MEDICAL HISTORY',
//     value: 1
//   },
//   { name: 'RESISTANCE TRAINING', value: 2 },
//   {
//     name: 'AEROBIC EXERCISE',
//     value: 3
//   },
//   {
//     name: 'NUTRITION & EATING HABITS',
//     value: 4
//   },
//   {
//     name: 'REJUVENATION',
//     value: 5
//   }
// ]

// const mattermeQuestionSection = [
//   {
//     name: 'GOALS',
//     value: 1
//   },
//   { name: 'MEDICAL HISTORY', value: 2 },
//   {
//     name: 'AEROBIC EXERCISE',
//     value: 3
//   },
//   {
//     name: 'RESISTANCE TRAINING',
//     value: 4
//   },
//   {
//     name: 'ACTIVITY EXERCISE',
//     value: 5
//   },
//   {
//     name: 'NUTRITION & EATING HABITS',
//     value: 6
//   },
//   { name: 'REJUVENATION', value: 7 }
// ]

const questionSection = sections
// env === 'staging' ? stagingQuestionSection : mattermeQuestionSection

export const questionnaireConfig = {
  sections: questionSection.map((item) => item.value),
  nutritionId: 7, //env === 'staging' ? 7 : 6, // on staging is 7
  questionSection,
  surveyId: 4, //env === 'staging' ? 4 : 20, // on staging is 4
  surveyName: 'Client Intake Form 3.0'
  // env === 'staging' ? 'Client Intake Form 3.0' : 'Client Intake Form 4.0'
}

export const healthCardList = [
  {
    name: 'Balance',
    type: 'balance',
    description:
      'Balance disorders are one of the most common causes of falls in older adults. Maintaining good balance from now will help prevent daily difficulties when you’re older: getting in and out of cars, climbing stairs, and taking showers.'
  },
  {
    name: 'Movement Quality',
    type: 'joint_fitness', //'movement_quality',
    description:
      'By maintaining a healthy movement pattern as you age, you’ll be able to perform essential activities of daily living in older years, such as tying your shoes, lifting up your grandkids, and washing your head. Also, good movement quality could lubricate the joints and reduce your risk of arthritis.'
  },
  {
    name: 'Muscle Fitness',
    type: 'muscular_fitness',
    description:
      'Good muscular fitness is essential for staying functional as you age (e.g., being able to climb stairs easily) and resisting sarcopenia (loss of skeletal muscle mass). It also helps prevent bone fractures in the event you fall or get injured. '
  },
  {
    name: 'Body Composition',
    type: 'body_composition',
    description:
      'Your score looks beyond scale weight and considers the three most important factors for health and longevity. Body fat percentage, the percentage of your body weight that consists of fat as measured by DXA. Visceral adipose tissue, a type of body fat linked to higher risk for heart disease and Type 2 diabetes. And appendicular lean mass, which important for strength, function, metabolism, and storage of nutrients.'
    // 'Your score looks beyond your weight to consider your body fat percentage and amount of visceral adipose tissue, a type of body fat linked to higher risk for heart disease and Type 2 diabetes.'
  },
  {
    name: 'Bone Density',
    type: 'bone_health', //'bone_density',
    description:
      'As you age, your bone density is affected by nutrition, exercise, hormonal loss, and even genetics. Your score considers your risk of having a bone fracture, particularly in prone areas such as your back and hip.'
  },
  {
    name: 'Aerobic fitness',
    type: 'aerobic_fitness',
    description:
      'Your score is a measure of your body’s ability to deliver oxygen to your muscle cells and use it to generate energy. While good aerobic fitness is important for all decades of life, it has been associated with better brain and heart health in older age.'
  },
  {
    name: 'Cognitive Health',
    type: 'cognitive_health',
    description:
      'Cognitive health refers to the overall functioning and well being of the brain and its ability to process information, think critically, and make decisions. Factors that can impact cognitive health include genetics, age, lifestyle, and medical conditions. Maintaining cognitive health involves engaging in activities that stimulate the brain (E.g. reading, puzzles, and social interaction) and adopting healthy habits like getting enough sleep, exercising regularly, and managing stress.'
  },
  {
    name: 'Cardiometabolic',
    type: 'cardiometabolic',
    description:
      'Your score emcompasses the health of your heart, blood vessels, and metabolism. It considers your risk for developing heart disease and Type 2 diabetes, two prevalent chronic diseases.'
  }

  // {
  //   name: 'Total Apeiron Life score',
  //   key: 'cardiometabolic',
  //   description: 'We create a composite score with all of your health and fitness data, giving you one number to monitor over time. Like all of your scores, this is adjusted for your age and gender.'
  // }
]

export const muscleMetricsWithBodyChart = [
  'Hip Abduction Total',
  'Hip Adduction Total',
  'Knee Flexion',
  'Knee Extension'
]

export const BookedFor = [
  { label: 'Self', value: 'self' },
  { label: 'Spouse', value: 'spouse' },
  { label: 'Kid', value: 'kid' },
  { label: 'Parent', value: 'parent' },
  { label: 'Sibling', value: 'sibling' },
  { label: 'Other', value: 'other' }
]

export const transactionReasons = [
  'Appointment Completed',
  'Appointment Cancelled',
  'Membership Purchased',
  'Membership Renewal',
  'Membership Ended',
  'Extra Sessions Purchased',
  'Other'
]

export const AppointmentStatus = [
  { label: 'Completed', value: 'Completed' },
  { label: 'Canceled', value: 'Canceled' },
  { label: 'Not Started', value: 'Not Started' }
]

export const Locations = [
  { label: 'Home', value: 'home' },
  { label: 'ApeironLife', value: 'apeironlife' },
  { label: 'Virtual', value: 'virtual' }
]

export const defaultSessionPricingData = [
  {
    key: '1',
    locations: 'Home',
    sessionsUsed: '1.2',
    clientPay: '200'
  },
  {
    key: '2',
    locations: 'ApeironLife',
    sessionsUsed: '1',
    clientPay: '200'
  },
  {
    key: '3',
    locations: 'Virtual',
    sessionsUsed: '1',
    clientPay: '200'
  },
  {
    key: '4',
    locations: 'Other',
    sessionsUsed: '1',
    clientPay: '200'
  }
]

export const membershipTypes = [
  { value: 'insights', label: 'Healthspan Insights' },
  { value: 'body recomposition', label: 'Body Recomposition' },
  { value: 'evaluation2', label: 'Healthspan Assessment' },
  { value: 'gold', label: 'Gold Membership' },
  { value: 'silver', label: 'Silver Membership' },
  { value: 'bronze', label: 'Bronze Membership' },
  { value: 'remote', label: 'Remote Membership' },
  { value: 'remote lite', label: 'Remote Lite Membership' },
  { value: 'core', label: 'Core A La Carte' },
  { value: 'core+', label: 'Core' },
  { value: 'lite', label: 'Apeiron Lite' },
  { value: 'module', label: 'Module Membership' }
]

export const healthySignalsDataTypes = [
  'Exercise Signals',
  'Sleep Signals',
  'Healthy Signals'
]

export const sleepDataSources = [
  'ouraring',
  'healthkit',
  'garmin'
]

export const IGNORED_METRICS_FOR_LIFESTYLE_RECOMMENDATIONS = [
  'IGF-1',
  'Total Protein',
  'Phosphorous',
  'femoral_neck_z_score_age_ranking',
  'lumbar_spine_z_score_age_ranking',
  'AppendicularLMI',
  'weight_lbs',
  'fat_mass_lbs',
  'lean_mass_lbs',
  'height_inches',
  'target_body_weight',
  'target_fat_mass',
  'target_lean_mass',
  'left_arm_fat',
  'right_arm_fat',
  'trunk_fat',
  'left_leg_fat',
  'right_leg_fat',
  'tmt_a',
  'targets_per_minute',
  'brainCheck_combined_score',
  'trails_a_ranked',
  'trails_b_ranked',
  'digit_symbol_substitution_ranked',
  'stroop_ranked',
  'immediate_recognition_ranked',
  'delayed_recognition_ranked',
  'grip_strength_left',
  'grip_strength_right',
  'grip_strength_age_ranked',
  'grip_strength_diff',
  'sit_to_stand_age_ranked',
  'anterior_reach_left',
  'anterior_reach_right',
  'postero_medial_reach_left',
  'postero_medial_reach_right',
  'postero_lateral_reach_left',
  'postero_lateral_reach_right',
  'knee_to_wall_left',
  'knee_to_wall_right'
]

export const appleCompanies = ['Apple - Cupertino', 'Apollo - New York']

export const companies = [
  { value: 'Apeiron Life', label: 'Apeiron Life' },
  { value: 'Apple - Cupertino', label: 'Apple - Cupertino' },
  { value: 'Apollo - New York', label: 'Apollo - New York' },
  { value: 'Workday - Pleasanton', label: 'Workday - Pleasanton' }
]

export const baseMemberships = [
  'evaluation2', 'insights', 'insights+', 'body recomposition',
  'gold', 'silver', 'bronze',
  'module', 'core', 'core+',
  'remote', 'remote lite'
]

const membershipsForAppleApolloClients = ['Condition Assessment', 'Fitness Assessment']

export const companyMembershipMap = {
  'Apeiron Life': baseMemberships,
  'Apple - Cupertino': [...membershipsForAppleApolloClients, ...baseMemberships],
  'Apollo - New York': baseMemberships,
  'Workday - Pleasanton': baseMemberships
}

export const membershipOptions = [
  { value: 'Condition Assessment', label: 'Condition Assessment' },
  { value: 'Fitness Assessment', label: 'Fitness Assessment' },
  { value: 'evaluation2', label: 'Healthspan Assessment' },
  { value: 'insights', label: 'Healthspan Insights' },
  { value: 'insights+', label: 'Insights+' },
  { value: 'body recomposition', label: 'Body Recomposition' },
  { value: 'gold', label: 'Gold Membership' },
  { value: 'silver', label: 'Silver Membership' },
  { value: 'bronze', label: 'Bronze Membership' },
  { value: 'remote', label: 'Remote Membership' },
  { value: 'remote lite', label: 'Remote Lite Membership' },
  { value: 'module', label: 'Module Membership' },
  { value: 'core', label: 'Core A La Carte', hidden: true },
  { value: 'core+', label: 'Core', hidden: true }
]

export const isoMetrics = [
  'Single Arm Isometric Pull Asymmetry',
  'Single Arm Isometric Pull/BW Total',
  'Single Arm Isometric Press Asymmetry',
  'Single Arm Isometric Press/BW Total',
  'Total Limitations',
  'Total Pain Points'
]

export const archiveMetrics = [
  'Peak Drop Landing Force (L)',
  'Peak Drop Landing Force (R)',
  'Time to Stabilization (L)',
  'Time to Stabilization (R)',
  'Time to Stabilization Asymmetry (L/R)',
  'Time to Stabilization (Both Legs)',
  'Hip Flexion (L)',
  'Hip Flexion (R)',
  'Hip Flexion Difference',
  'Hip Extension (L)',
  'Hip Extension (R)',
  'Hip Extension Difference',
  'Landing Asymmetry',
  'Single Leg Stance CoP',
  'Area of CoP Ellipse',
  'Postural Sway Asymmetry (Eyes Open)',
  'Postural Sway Asymmetry (Eyes Closed)',
  'Slope',
  'Y-Int'
]

export const excludedBloodMetrics = [
  'Total Protein',
  'Calcium',
  'Potassium',
  'Phosphorous',
  'RBC Magnesium',
  'Bilirubin',
  'Albumin',
  'Alkaline Phosphatase',
  'Total Protein',
  'EPA(Legacy)',
  'DHA(Legacy)',
  'HS CRP'
]

export const nonV2SectionExclusions = {
  'Vitamin and Mineral': ['DHA', 'EPA', 'DPA', 'Omega 3 Total'],
  'Key Nutrients': ['DHA', 'EPA', 'DPA', 'Omega 3 Total'],
  'Inflammation': ['Oxidized LDL', 'Omega 3 Total', 'LP PLA2'],
  'Advanced Cardiovascular': ['Oxidized LDL']
}

export const v2SectionExclusions = {
  'Advanced Cardiovascular': ['Omega 3 Total']
}

export function getV2DisplayName(display_name, name) {
  const displayNameMap = {
    'LDL': 'LDL Cholesterol',
    'HDL': 'HDL Cholesterol',
    'Total cholesterol': 'Total Cholesterol',
    'Estimated GFR': 'Estimated GFR',
    'BUN': 'BUN',
    'Iron': 'Iron',
    '25-OH Vitamin D': 'Vitamin D',
    'Omega 3 Total': 'Omega-3 Total',
    'HsCRP': 'hsCRP',
    'ApoB': 'ApoB',
    'LP(a)': 'LP(a)',
    'LP PLA2': 'LP PLA2 Activity',
    'fasting glucose': 'Glucose',
    'HgbA1-C': 'Hemoglobin A1c',
    'Insulin': 'Insulin'
  }
  if (displayNameMap.hasOwnProperty(display_name)) {
    return displayNameMap[display_name]
  }
  return name || display_name
}

export const DOCUMENT_ICON_COLORS = {
  pdf: '#d32f2f',
  article: '#1976d2',
  youtube: '#ff0000'
}

export const DOCUMENT_ICON_SIZE = 20

export const DOCUMENT_TYPE_LABELS = {
  other: 'PDF',
  txt: 'Article',
  youtube: 'Video',
  default: 'Article'
}

export const BOT_INTRO_MESSAGE = 'Based on your query, You might find these articles from our Knowledge Hub helpful !'

export const BOT_RESOURCE_LOCATION = 'Apeiron Life'

export const BOT_ACTION_TEXTS = {
  other: 'Read PDF',
  youtube: 'Watch Video',
  default: 'Read Article'
}
export const BOT_USER_ID = 'Akash_0'

export const BOT_USER_NAME = 'Akash Gadhave'

export const SLEEP_SIGNALS_WEIGHTING_TYPE = {
  SLEEP_ALGORITHM: 'sleep_algorithm',
  HSD_SCORES: 'hsd_scores'
}

export const questionnaireHierarchyOrder = {
  'Lifestyle & Goals': 1,
  'Medical History': 2,
  'Medications & Supplements': 3,
  'Capacity to Exercise (CTE)': 4,
  'Physical Activity': 5,
  'Nutrition Signals Questionnaire': 6,
  'Sleep Questionnaire': 7,
  'Menopause Symptoms': 8
}

export const EXERCISE_QUESTIONS = [
  {
    id: 'relevance_alignment',
    title: 'Relevance & Alignment (1-10)',
    definition: 'How well the response addresses the client\'s stated goals, exercise gap analysis, and provided health data.',
    hint: 'Check whether the main recommendations directly reference client metrics/goals.'
  },
  {
    id: 'completeness_structure',
    title: 'Completeness & Structure (1-10)',
    definition: 'The response follows required format (Weeks 1–2, 3–4, 5–6 + rationale, 2–3 actions each, recovery, progression) and includes all requested sections.',
    hint: 'Give a low score if any of the three bi-weekly blocks or required subheadings are absent.'
  },
  {
    id: 'specificity_actionability',
    title: 'Specificity / Actionability (1-10)',
    definition: 'Recommendations are concrete, measurable (frequency, duration, intensity), and usable without clarification.',
    hint: 'Prefer formats like "30 min brisk walk, 5×/week, RPE 5–6" over "increase cardio".'
  },
  {
    id: 'safety_clinical_soundness',
    title: 'Safety & Clinical Soundness (1-10)',
    definition: 'No contraindicated or risky advice; medical red flags are called out; intensity matches risk profile.',
    hint: 'Give a low score if it suggests HIIT for a client with a recent cardiac event or unresolved injury.'
  },
  {
    id: 'personalization_contextual_tailoring',
    title: 'Personalization / Contextual Tailoring (1-10)',
    definition: 'Advice is adapted to client preferences, constraints (time/equipment/culture), sleep & nutrition context, and biomarker data.',
    hint: 'Check for explicit mention of sleep/nutrition ties and constraints (e.g., travel, shift work).'
  },
  {
    id: 'progression_continuity',
    title: 'Progression & Continuity (1-10)',
    definition: 'The 6-week plan shows clear bi-weekly progression, builds on prior blocks, and gives light/moderate/vigorous options and recovery days.',
    hint: 'Look for incremental load increases and fallback plans for travel/recovery.'
  }
]

export const NUTRITION_QUESTIONS = [
  {
    id: 'relevance_alignment',
    title: 'Relevance & Alignment (1-10)',
    definition: 'How well the recommendations address the client\'s stated nutrition goals, survey inputs, and biomarker data.',
    hint: 'Check whether the recommendations reference the client\'s actual patterns, gaps, or metrics (e.g., high A1c, low protein intake, low fiber score).'
  },
  {
    id: 'completeness_structure',
    title: 'Completeness & Structure (1-10)',
    definition: 'The response follows the required structure for each recommendation:\nTitle → Current Situation → Why Change It? → Recommendation → Why This Recommendation?\nIncludes no more than 6 properly developed recommendations.',
    hint: 'Give a low score if any recommendation lacks a section or skips "Why Change It?" or "Why This Recommendation?".'
  },
  {
    id: 'specificity_actionability',
    title: 'Specificity / Actionability (1-10)',
    definition: 'Recommendations are concrete, measurable, and implementable without clarification.\nUses supportive, client-friendly language ("try", "consider", "may help").',
    hint: 'Prefer numeric or behavior-specific suggestions over vague guidance.'
  },
  {
    id: 'safety_clinical_soundness',
    title: 'Safety & Clinical Soundness (1-10)',
    definition: 'Recommendations do not encourage unsafe dieting practices, extreme restriction, or advice outside nutrition scope.\nAppropriately responds to clinical biomarkers (e.g., prediabetes, dyslipidemia) without stepping into medical diagnosis.',
    hint: 'Give low scores for: extreme fasting, huge calorie deficits, "eliminate entire food groups", advice that contradicts the client\'s medical risks.'
  },
  {
    id: 'personalization_contextual_tailoring',
    title: 'Personalization / Contextual Tailoring (1-10)',
    definition: 'Advice is adapted to client preferences, constraints (time/equipment/culture), sleep & nutrition context, and biomarker data.',
    hint: 'Look for explicit mentions of the client\'s routines, food preferences, or specific dietary challenges.'
  },
  {
    id: 'feasibility_behavioral_continuity',
    title: 'Feasibility & Behavioral Continuity (1-10)',
    definition: 'Recommendations encourage gradual adoption, sustainable habits, and realistic steps that build on existing behaviors.\nShows continuity with the client\'s current patterns and focuses on incremental change.',
    hint: 'Check whether the changes feel reasonable for this specific client (time constraints, habits, readiness).'
  }
]

export const SLEEP_QUESTIONS = [
  {
    id: 'relevance_alignment',
    title: 'Relevance & Alignment (1-10)',
    definition: 'How well the recommendations address the client\'s graded survey flags, and wearable sleep metrics, with attention to discrepancies.',
    hint: 'Do the recommendations clearly map to flagged issues?\nAre wearable trends explicitly referenced where relevant?\nDoes it avoid generic "sleep better" suggestions?'
  },
  {
    id: 'completeness_structure',
    title: 'Completeness & Structure (1-10)',
    definition: 'The response includes no more than 6 areas, each with Title, Current Situation, Importance, Recommendation, and includes the Progress & Trajectory Analysis if the client is a repeat case.',
    hint: 'Count: ≤6 items?\nEach item has all 4 required subsections?\nProgress section fully present when required?'
  },
  {
    id: 'specificity_actionability',
    title: 'Specificity & Actionability (1-10)',
    definition: 'Recommendations are clear, realistic, and actionable: "try," "may," measurable steps, timing, and behavioral experiments.',
    hint: 'Check for vague terms ("optimize," "improve") vs. concrete actions ("try limiting caffeine after 1pm").\nShould be usable with no clarification.'
  },
  {
    id: 'safety_clinical_soundness',
    title: 'Safety & Clinical Soundness (1-10)',
    definition: 'Advice avoids risks, acknowledges chronic patterns, and recommends escalation when indicators suggest possible disorders.',
    hint: 'No contraindicated advice for apnea, insomnia, or other risks.\nMust avoid over-claims ("guaranteed improvement").\nShould identify red flags in wearable or survey data.'
  },
  {
    id: 'personalization_contextual_tailoring',
    title: 'Personalization & Contextual Tailoring (1-10)',
    definition: 'Recommendations incorporate: survey flags, lifestyle patterns (shift work, travel, and alcohol), wearable trends, and discrepancies between self-report and sensor data',
    hint: 'Look for explicit client context.\nNot generic wellness advice.\nMatches constraints and habits.'
  },
  {
    id: 'prioritization_impact_ordering',
    title: 'Prioritization & Impact Ordering (1-10)',
    definition: 'The list is ordered by clinical importance, frequency, and chronicity of sleep disruptions. Significant issues appear first.',
    hint: 'Apnea/snoring > chronic latency issues > inconsistent schedule > episodic behaviors.\nMinor hygiene issues should not be at the top.'
  }
]

export const HOLISTIC_QUESTIONS = [
  {
    id: 'goal_alignment_domain_prioritization',
    title: 'Goal Alignment & Domain Prioritization (1-10)',
    definition: 'How well the introduction clearly states the client\'s primary goals and identifies the healthspan domains most relevant to those goals.',
    hint: 'Does it mention the client\'s goals directly?\nDoes it reference only the relevant domains (e.g., Sleep, Exercise, Nutrition, Stress)?\nDoes it avoid mentioning specific metrics or specific recommendations?'
  },
  {
    id: 'use_of_domain_scores',
    title: 'Use of Domain Scores to Identify Opportunities (1-10)',
    definition: 'How well the introduction uses the client\'s current domain scores to highlight areas of opportunity without giving numbers or targets.',
    hint: 'Does it indicate which domains show room for improvement?\nDoes it avoid any specific numeric values?\nDoes it present opportunity positively, not critically?'
  },
  {
    id: 'tone_accessibility_encouragement',
    title: 'Tone, Accessibility, & Encouragement (1-10)',
    definition: 'The writing should be client-facing, supportive, motivating, and scientifically grounded, while avoiding medical jargon or meta-commentary.',
    hint: 'Tone should feel warm and empowering.\nMust speak directly to the client ("you").\nUses "may" instead of "can."'
  },
  {
    id: 'structure_focus_conciseness',
    title: 'Structure, Focus, & Conciseness (1-10)',
    definition: 'The introduction should be maximum 5 sentences, tightly focused, and not mention specific recommendations, metrics, or detailed protocols.',
    hint: 'Count: ≤5 sentences.\nShould present only high-level concepts.\nNo specifics from the sleep/nutrition/exercise protocols.'
  }
]

export const RECOMMENDATIONS_QUESTIONS = [
  {
    id: 'realism_scientific_accuracy',
    title: 'Realism & Scientific Accuracy (1-10)',
    definition: 'How well the expectations are grounded in realistic physiological timelines and evidence-based adaptation patterns (sleep, exercise, nutrition, biomarkers).',
    hint: 'Look for "may" language.\nNo promises ("will"), no exact timelines for biomarkers unless grounded in typical physiological response.'
  },
  {
    id: 'alignment_client_goals_metrics',
    title: 'Alignment With Client Goals & Metrics (1-10)',
    definition: 'How well the expectations connect to the client\'s specific goals and the healthspan domains relevant to those goals.',
    hint: 'Does the text reference goal categories, not numeric values?\nAre the described changes logically tied to the nutrition/sleep/exercise recommendations provided?'
  },
  {
    id: 'completeness_required_sections',
    title: 'Completeness of Required Sections (1-10)',
    definition: 'Covers all four required blocks:\nEarly Changes (first month)\nProgressive Improvements (2–3 months)\nLong-Term Vision (3+ months)\nPersonalization Note',
    hint: 'Mark down if:\nAny section is missing\nSections are merged or out of order\nPersonalization note isn\'t present'
  },
  {
    id: 'specificity_vividness',
    title: 'Specificity & Vividness (1-10)',
    definition: 'How effectively the model paints a clear, engaging, client-friendly picture of potential improvements without promising outcomes.',
    hint: 'Avoid generic statements ("you may feel better").\nPrefer vivid but realistic examples ("your workouts may begin to feel smoother as recovery improves").\nNo numerical predictions (e.g., "lose 10 lbs").'
  },
  {
    id: 'tone_empowerment_client_friendliness',
    title: 'Tone, Empowerment & Client-Friendliness (1-10)',
    definition: 'The language is supportive, motivational, second-person ("you"), and uses non-prescriptive, empowerment-oriented phrasing.',
    hint: 'No meta-commentary.\nNo coaching jargon or lectures.\nUses "may" > "can."\nFeels encouraging, not clinical or robotic.'
  },
  {
    id: 'integration_personalization_individual_variability',
    title: 'Integration of Personalization & Individual Variability (1-10)',
    definition: 'Acknowledges that responses vary between individuals, references the client\'s unique factors (goals, habits, protocols), and sets expectations responsibly.',
    hint: 'Does it explicitly mention individual variation?\nDoes it avoid universal guarantees?\nDoes it incorporate relevant trends if this is a returning client?'
  }
]

export const NEXT_STEPS_QUESTIONS = [
  {
    id: 'personalization_client_goals_health_metrics',
    title: 'Personalization to Client Goals & Health Metrics (1-10)',
    definition: 'How well the response connects Apeiron\'s support to the client\'s specific goals, biomarkers, health metrics, and priority healthspan domains.',
    hint: 'Must reference relevant biomarkers or metrics conceptually, without listing values.\nShould align to the client\'s stated goals (e.g., energy, body composition, metabolic health, sleep consistency).\nAvoids generic statements like "Helps you improve your health."'
  },
  {
    id: 'integration_sleep_nutrition_exercise',
    title: 'Integration of Sleep, Nutrition, and Exercise Recommendations (1-10)',
    definition: 'Assesses whether the response clearly shows how recommendations work together and how Apeiron helps weave them into the client\'s routine.',
    hint: 'Should mention interconnection (e.g., nutrition supporting workouts, sleep supporting recovery).\nShould feel cohesive, not like separate pillars.\nMust remain within two sentences.'
  },
  {
    id: 'explanation_personalized_support',
    title: 'Explanation of How Personalized Support Enables Implementation & Adaptation (1-10)',
    definition: 'Evaluates whether the response expresses how Apeiron helps the client implement, adjust, and sustain their plan over time.',
    hint: 'Look for language about guidance, adaptation, accountability, or support.\nAvoid operational details like listing services (prohibited).\nShould highlight personalization rather than general coaching.'
  },
  {
    id: 'tone_supportive_empowering',
    title: 'Use of Supportive, Empowering, Client-Facing Tone (1-10)',
    definition: 'The tone must be supportive, positive, second-person, realistic, and empowering — consistent with the system message.',
    hint: 'Must address "you."\nNever instructional ("You must…", "You should…).\nAvoid clinical, overly technical, or detached tone.\nAvoid meta-commentary.'
  },
  {
    id: 'scientific_credibility_correctness',
    title: 'Scientific Credibility & Correctness (1-10)',
    definition: 'The response should be evidence-aligned, physiology-aware, and avoid inaccurate or exaggerated claims.',
    hint: 'Look for appropriate "may" language.\nAvoid guaranteed outcomes ("will fix," "ensures").\nNo pseudoscience or unrealistic timelines.'
  },
  {
    id: 'brevity_clarity_two_sentence_constraint',
    title: 'Brevity, Clarity & Two-Sentence Constraint (1-10)',
    definition: 'The output must be exactly two sentences, concise, clear, and easy for a client to read while still containing rich meaning.',
    hint: 'Two sentences only — no fragments, no semicolon chains pretending to be separate sentences.\nEach sentence should be meaningful and not overloaded.\nNo lists of services (per instructions).'
  }
]

export const SESSION_ALERT_EMAIL_TYPE = {
  session_purchase: 'Session Purchase',
  alert: 'Alert'
}

// Marketing-site-inspired styling (Inter font + earthy brand palette) is rolled out
// only for specific clients. Other clients keep the current AR deck styling.
export const isMarketingSiteEnabled = (person) => {
  // Apply the new look only for client id 1217 and leave every other client
  // with the current styling.
  return !!(person && person.id === 1217)
}

export const isProtocolInfographicEnabled = (person) => {
  if (!person) return false
  return (
    (process.env.REACT_APP_WORKFLOW === 'production' && (person.id === 360 || person.id === 35)) ||
    (process.env.REACT_APP_WORKFLOW === 'staging' && person.id === 1233) ||
    (process.env.REACT_APP_WORKFLOW === 'develop' && person.id === 1233)
  )
}

export const SESSION_ALERT_EMAIL_TEMPLATE = `Dear [Client Name],

You have used [22 out of the 25] Apeiron sessions included in your [Bronze] membership.

To bridge the gap before your renewal on [DATE], would you like to add a session package? Any sessions purchased now that remain unused will carry over to your next membership year.

Options include:
25 Sessions: $5,500
50 Sessions: $11,000

Best,
Apeiron Concierge Team`
